import script from "./FooterInfo.vue?vue&type=script&setup=true&lang=ts&name=FooterInfo"
export * from "./FooterInfo.vue?vue&type=script&setup=true&lang=ts&name=FooterInfo"

import "./FooterInfo.vue?vue&type=style&index=0&id=3c245880&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c245880"]])

export default __exports__